module.exports = __webpack_public_path__ + "static/media/jessica_2013.2767c311.jpeg";